/**
 * @ngdoc directive
 * @name Characters Counter
 *
 * @description
   Shows warning / error message when chars in variable are close to / reached max length of variable
   Can be used in input to show warning message about characters left to its maxlength
 *
 * @scope
 * @param {Number} maxlength - max length of variable
 * @param {Number} startWarning - when should we start showing warning message
 * @param {String} variable - variable to check
 *
 * @example
   <div class='is-relative' style='height: 60px'>
   <chars-counter maxlength="15" start-warning="11" variable="'No warning'" style='left: 2px'></chars-counter>
   <chars-counter maxlength="15" start-warning="10" variable="'Has warning'" style='left: 50%'></chars-counter>
   <chars-counter maxlength="15" start-warning="10" variable="'Has error......'"></chars-counter>
   </div>
 */

(function() {

  charsCounter.$inject = ["PATH"];
  app.directive('charsCounter', charsCounter);

  function charsCounter (PATH) {
    var directive = {
      restrict: 'E',
      replace: true,
      scope: {
        maxlength: '@',
        startWarning: '@',
        variable: '='
      },
      templateUrl: PATH.components + 'charsCounter/charsCounter.html',
      link: link
    };

    return directive;

    function link($scope, $element, $attrs) {
      $scope.$watch('variable', function () {
        var length = $scope.variable && $scope.variable.length || 0;
        $scope.charsLeft = numeral($scope.maxlength) - length;
        $scope.showError = false;
        $scope.showWarning = false;

        if ($scope.charsLeft === 0) {
          $scope.showError = true;
        } else if (numeral($scope.startWarning) >= $scope.charsLeft) {
          $scope.showWarning = true;
        }
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/charsCounter/charsCounterDirective.js